// Customer Care Drawer JavaScript
document.addEventListener('DOMContentLoaded', function () {
  const customerCareTrigger = document.querySelector('.customer-care-trigger');
  const customerCareDrawer = document.getElementById('customer-care-drawer');
  const customerCareClose = document.querySelector('.customer-care-drawer__close');
  const customerCareOverlay = document.querySelector('.customer-care-drawer__overlay');
  const appointmentButton = document.querySelector('.customer-care-drawer__appointment-button');
  const backButton = document.querySelector('.customer-care-drawer__back-button');
  const mainPage = document.querySelector('.customer-care-drawer__main-page');
  const appointmentPage = document.querySelector('.customer-care-drawer__appointment-page');

  if (customerCareTrigger && customerCareDrawer) {
    // Open drawer
    customerCareTrigger.addEventListener('click', function (e) {
      e.preventDefault();
      customerCareDrawer.style.display = 'block';
      setTimeout(() => {
        customerCareDrawer.classList.add('open');
      }, 10);
      document.body.style.overflow = 'hidden';
    });

    // Close drawer
    function closeDrawer() {
      customerCareDrawer.classList.remove('open');
      setTimeout(() => {
        customerCareDrawer.style.display = 'none';
        document.body.style.overflow = '';
        // Reset to main page
        showMainPage();
      }, 300);
    }

    // Show main page
    function showMainPage() {
      if (mainPage && appointmentPage) {
        mainPage.style.display = 'block';
        appointmentPage.style.display = 'none';
        mainPage.classList.remove('slide-out');
        appointmentPage.classList.remove('slide-in');
      }
    }

    // Show appointment page
    function showAppointmentPage() {
      if (mainPage && appointmentPage) {
        appointmentPage.style.display = 'block';
        setTimeout(() => {
          mainPage.classList.add('slide-out');
          appointmentPage.classList.add('slide-in');
        }, 10);
      }
    }

    // Appointment button click
    if (appointmentButton) {
      appointmentButton.addEventListener('click', function (e) {
        e.preventDefault();
        showAppointmentPage();
      });
    }

    // Back button click
    if (backButton) {
      backButton.addEventListener('click', function (e) {
        e.preventDefault();
        showMainPage();
      });
    }

    // Close button
    if (customerCareClose) {
      customerCareClose.addEventListener('click', closeDrawer);
    }

    // Overlay click
    if (customerCareOverlay) {
      customerCareOverlay.addEventListener('click', closeDrawer);
    }

    // ESC key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && customerCareDrawer.classList.contains('open')) {
        if (appointmentPage && appointmentPage.style.display !== 'none') {
          showMainPage();
        } else {
          closeDrawer();
        }
      }
    });
  }

  // Appointment form: WhatsApp by selected city with filled body (labels from locale)
  let appointmentMailLabels = {};
  try {
    const labelsEl = document.getElementById('appointment-mail-labels');
    if (labelsEl && labelsEl.textContent) {
      appointmentMailLabels = JSON.parse(labelsEl.textContent);
    }
  } catch (err) {}
  const appointmentForm = document.querySelector('[data-appointment-mailto-form]');
  if (appointmentForm) {
    appointmentForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const L = appointmentMailLabels;
      const nameEl = document.getElementById('appointment-name');
      const emailEl = document.getElementById('appointment-email');
      const phoneEl = document.getElementById('appointment-phone');
      const cityEl = document.getElementById('appointment-city');
      const dateEl = document.getElementById('appointment-date');
      const timeEl = document.getElementById('appointment-time');
      const serviceEl = document.getElementById('appointment-service');
      const messageEl = document.getElementById('appointment-message');
      if (!cityEl || !cityEl.value) return;
      const whatsappNumber = cityEl.value;
      const cityLabel = cityEl.options[cityEl.selectedIndex]?.text || cityEl.value;
      const name = nameEl?.value?.trim() || '';
      const email = emailEl?.value?.trim() || '';
      const phone = phoneEl?.value?.trim() || '';
      const date = dateEl?.value || '';
      const time = timeEl?.options[timeEl.selectedIndex]?.text || timeEl?.value || '';
      const service = serviceEl?.options[serviceEl.selectedIndex]?.text || serviceEl?.value || '';
      const message = messageEl?.value?.trim() || '';
      const body = [
        L.title || 'RANDEVU TALEBİ',
        '',
        L.name || 'Ad:',
        name,
        '',
        L.email || 'E-posta:',
        email,
        '',
        L.phone || 'Telefon:',
        phone,
        '',
        L.city || 'Şehir:',
        cityLabel,
        '',
        L.date || 'Tercih Edilen Tarih:',
        date,
        '',
        L.time || 'Tercih Edilen Saat:',
        time,
        '',
        L.service || 'Hizmet:',
        service,
        '',
        L.message || 'Mesaj:',
        message
      ].join('\n');
      const textEnc = encodeURIComponent(body).replace(/\+/g, '%20');
      const whatsappUrl = 'https://wa.me/' + whatsappNumber + '?text=' + textEnc;
      window.open(whatsappUrl, '_blank', 'noopener');
    });
  }
});

// Newsletter Form Submit Handler
document.addEventListener('DOMContentLoaded', function () {
  // Check if we're on a success page (customer_posted=true)
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('customer_posted') === 'true') {
    // Redirect to login page after successful newsletter subscription
    window.location.href = '/account/login';
    return;
  }

  const newsletterForms = document.querySelectorAll('form[id^="newsletter-form-"]');
  
  newsletterForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(form);
      const email = formData.get('contact[email]');
      
      if (!email) {
        return;
      }
      
      // Submit form normally - Shopify will handle the redirect
      form.submit();
    });
  });
});

// Shop the Look Fullwidth Carousel
if (!customElements.get('shop-the-look-fullwidth-carousel')) {
  class ShopTheLookFullwidthCarousel extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.items = [];
      this.prevButton = null;
      this.nextButton = null;
      this.resizeTimeout = null;
      this.boundHandleResize = null;
    }

    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.shop-the-look-fullwidth-item'));
      this.prevButton = this.parentElement.querySelector('.shop-the-look-arrow--prev');
      this.nextButton = this.parentElement.querySelector('.shop-the-look-arrow--next');

      this.initializeCarousel();
      this.bindEvents();
    }

    disconnectedCallback() {
      this.cleanup();
    }

    initializeCarousel() {
      if (this.items.length === 0) return;
      this.updateArrows();
      
      this.items.forEach((item) => {
        const dataEls = item.querySelectorAll('.shop-the-look-product-data');
        const dots = item.querySelectorAll('.shop-the-look-fullwidth-dot');
        const dotsWrap = item.querySelector('.shop-the-look-fullwidth-dots');
        const count = dataEls.length;
        
        if (dotsWrap) dotsWrap.style.display = count <= 1 ? 'none' : '';
        dots.forEach((d, idx) => d.style.display = idx < count ? 'inline-block' : 'none');

        if (window.innerWidth <= 1024) this.adjustHotSpotsWidth(item);
      });
    }

    adjustHotSpotsWidth(item) {
      const imageWrapper = item.querySelector('.shop-the-look-fullwidth-image-wrapper');
      const image = item.querySelector('.shop-the-look-fullwidth-image');
      const hotSpots = item.querySelector('.shop-the-look-fullwidth-hot-spots');
      
      if (imageWrapper && image && hotSpots) {
        const updateWidth = () => {
          requestAnimationFrame(() => {
            const imgWidth = image.offsetWidth;
            if (imgWidth > 0) {
              hotSpots.style.width = `${imgWidth}px`;
            } else {
              const naturalWidth = image.naturalWidth;
              const naturalHeight = image.naturalHeight;
              if (naturalWidth > 0 && naturalHeight > 0) {
                const viewportHeight = window.innerHeight;
                const aspectRatio = naturalWidth / naturalHeight;
                const calculatedWidth = viewportHeight * aspectRatio;
                hotSpots.style.width = `${calculatedWidth}px`;
              }
            }
          });
        };
        if (image.complete) updateWidth();
        else image.addEventListener('load', updateWidth, { once: true });
        if (image.complete) setTimeout(updateWidth, 50);
      }
    }

    openTooltip(itemIndex, productIndex, tooltip, dot) {
      if (!tooltip || !dot) return;
      
      const currentItem = this.items[itemIndex];
      const productDataElement = currentItem.querySelector(`[data-dot-index="${productIndex}"]`);
      
      if (!productDataElement) return;

      const tooltipContent = tooltip.querySelector('.shop-the-look-fullwidth-tooltip-content');
      tooltipContent.setAttribute('data-product-url', productDataElement.dataset.productUrl || '');
      
      const image = tooltip.querySelector('.shop-the-look-fullwidth-tooltip-image img'); 
      const title = tooltip.querySelector('.tooltip-product-title');
      const designer = tooltip.querySelector('.tooltip-product-designer');
      const category = tooltip.querySelector('.tooltip-product-category');

      if (image) image.src = productDataElement.dataset.productImage || '';
      if (title) title.textContent = productDataElement.dataset.productTitle || 'Product';
      if (designer) designer.textContent = productDataElement.dataset.productDesigner || '';
      if (category) category.textContent = productDataElement.dataset.productCollection || ''; 

      tooltip.style.display = 'block';
      tooltip.classList.add('is-open');
      
      const allHotspots = currentItem.querySelectorAll('.shop-the-look-fullwidth-hot-spot');
      allHotspots.forEach(h => h.classList.remove('is-active'));
      dot.classList.add('is-active');

      const dots = currentItem.querySelectorAll('.shop-the-look-fullwidth-dot');
      dots.forEach((d, idx) => {
        d.classList.toggle('is-selected', idx === productIndex);
        d.setAttribute('aria-current', idx === productIndex ? 'true' : 'false');
      });

      requestAnimationFrame(() => {
        const dotRect = dot.getBoundingClientRect();
        const containerRect = this.getBoundingClientRect();
        const tooltipRect = tooltipContent.getBoundingClientRect();
        const viewportWidth = window.innerWidth;

        let top = dotRect.top - containerRect.top;
        let left = (dotRect.left - containerRect.left) + (dotRect.width / 2); 

        const spaceAbove = dotRect.top - containerRect.top;
        const spaceBelow = containerRect.height - (dotRect.top - containerRect.top + dotRect.height);
        const requiredHeight = tooltipRect.height + 20;

        let transformX = '-50%'; 
        let transformY = '-100%';
        let marginTop = -15;

        if (spaceAbove < requiredHeight) {
            transformY = '0%';
            marginTop = 15;

            if (spaceBelow < requiredHeight) {
                if (spaceAbove > spaceBelow) {
                     transformY = '-100%';
                     marginTop = -15;
                } else {
                     transformY = '0%';
                     marginTop = 15;
                }
            }
        }

        if (dotRect.left + (tooltipRect.width / 2) > viewportWidth - 20) {
           transformX = '-100%';
           left = (dotRect.left - containerRect.left) + dotRect.width;
        }
        else if (dotRect.left - (tooltipRect.width / 2) < 20) {
           transformX = '0%';
           left = (dotRect.left - containerRect.left);
        }

        tooltipContent.style.position = 'absolute';
        tooltipContent.style.left = `${left}px`;
        tooltipContent.style.top = `${top}px`;
        tooltipContent.style.transform = `translate(${transformX}, ${transformY})`;
        tooltipContent.style.marginTop = `${marginTop}px`;
        
        tooltipContent.style.right = 'auto';
        tooltipContent.style.bottom = 'auto';
      });
    }

    closeTooltip(tooltip) {
      if (!tooltip) return;
      tooltip.style.display = 'none';
      tooltip.classList.remove('is-open');
      
      const parentItem = tooltip.closest('.shop-the-look-fullwidth-item');
      if (parentItem) {
        parentItem.querySelectorAll('.shop-the-look-fullwidth-hot-spot.is-active')
          .forEach((el) => el.classList.remove('is-active'));
      }
    }

    bindDotEvents() {
      const allDots = this.querySelectorAll('.shop-the-look-fullwidth-hot-spot');
      if (allDots.length === 0) {
        setTimeout(() => this.bindDotEvents(), 200);
        return;
      }

      allDots.forEach((dot) => {
        const item = dot.closest('.shop-the-look-fullwidth-item');
        const itemIndex = Array.from(this.items).indexOf(item);
        const tooltip = item ? item.querySelector('.shop-the-look-fullwidth-tooltip') : null;
        const dotsInItem = item ? item.querySelectorAll('.shop-the-look-fullwidth-hot-spot') : [];
        const dotIndex = Array.from(dotsInItem).indexOf(dot);

        dot.addEventListener('click', (e) => {
          e.preventDefault(); e.stopPropagation();
          this.openTooltip(itemIndex, dotIndex, tooltip, dot);
        });
      });

      this.items.forEach((item, itemIndex) => {
        const localDots = item.querySelectorAll('.shop-the-look-fullwidth-dot');
        const hotspots = item.querySelectorAll('.shop-the-look-fullwidth-hot-spot');
        const tooltip = item.querySelector('.shop-the-look-fullwidth-tooltip');
        localDots.forEach((d, idx) => {
          d.addEventListener('click', (e) => {
            e.preventDefault(); e.stopPropagation();
            const hotspot = hotspots[idx] || null;
            this.openTooltip(itemIndex, idx, tooltip, hotspot);
          });
        });
      });
    }

    bindEvents() {
      if (this.prevButton) this.prevButton.addEventListener('click', () => this.previous());
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.next());

      setTimeout(() => this.bindDotEvents(), 100);

      setTimeout(() => {
        const allTooltips = this.querySelectorAll('.shop-the-look-fullwidth-tooltip');
        allTooltips.forEach((tooltip) => {
          const closeBtn = tooltip.querySelector('.shop-the-look-fullwidth-tooltip-close');
          const content = tooltip.querySelector('.shop-the-look-fullwidth-tooltip-content');

          if (closeBtn) closeBtn.addEventListener('click', () => this.closeTooltip(tooltip));
          tooltip.addEventListener('click', (e) => {
            if (content && !content.contains(e.target)) this.closeTooltip(tooltip);
          });

          if (content) {
            content.addEventListener('click', (e) => {
              if (closeBtn && (e.target === closeBtn || closeBtn.contains(e.target))) return;
              const targetUrl = content.getAttribute('data-product-url');
              if (targetUrl) window.location.href = targetUrl;
            });
          }
        });
      }, 100);

      this.boundHandleKeydown = (e) => {
        if (e.key === 'ArrowLeft') this.previous();
        if (e.key === 'ArrowRight') this.next();
        if (e.key === 'Escape') this.closeAllPopups();
      };
      this.addEventListener('keydown', this.boundHandleKeydown);

      let startX = 0, startY = 0, isDragging = false, scrollStartX = 0, scrollStartY = 0, isScrolling = false;

      this.boundHandleTouchstart = (e) => {
        const imageWrapper = e.target.closest('.shop-the-look-fullwidth-image-wrapper');
        if (imageWrapper && window.innerWidth <= 1024) {
          scrollStartX = imageWrapper.scrollLeft;
          scrollStartY = imageWrapper.scrollTop;
          isScrolling = false;
          return;
        }
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isDragging = true;
      };
      this.addEventListener('touchstart', this.boundHandleTouchstart, { passive: true });

      this.boundHandleTouchmove = (e) => {
        const imageWrapper = e.target.closest('.shop-the-look-fullwidth-image-wrapper');
        if (imageWrapper && window.innerWidth <= 1024) {
          const currentScrollX = imageWrapper.scrollLeft;
          const currentScrollY = imageWrapper.scrollTop;
          if (Math.abs(currentScrollX - scrollStartX) > 5 || Math.abs(currentScrollY - scrollStartY) > 5) {
            isScrolling = true;
          }
          return;
        }
        if (!isDragging) return;
      };
      this.addEventListener('touchmove', this.boundHandleTouchmove, { passive: true });

      this.boundHandleTouchend = (e) => {
        const imageWrapper = e.target.closest('.shop-the-look-fullwidth-image-wrapper');
        if (imageWrapper && window.innerWidth <= 1024 && isScrolling) {
          isScrolling = false; return;
        }
        if (!isDragging) return;
        isDragging = false;
        const endX = e.changedTouches[0].clientX;
        const endY = e.changedTouches[0].clientY;
        const diffX = startX - endX;
        const diffY = startY - endY;
        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
          if (diffX > 0) this.next(); else this.previous();
        }
      };
      this.addEventListener('touchend', this.boundHandleTouchend, { passive: true });

      this.boundHandleResize = () => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
          if (window.innerWidth <= 1024) {
            this.items.forEach((item) => {
              if (item.classList.contains('is-selected')) this.adjustHotSpotsWidth(item);
            });
          }
        }, 250);
      };
      window.addEventListener('resize', this.boundHandleResize);
    }

    select(index) {
      if (index < 0 || index >= this.items.length) return;
      this.currentIndex = index;

      this.items.forEach((item, i) => {
        if (i === index) {
          item.style.display = 'flex';
          void item.offsetWidth;
          item.classList.add('is-selected');
          setTimeout(() => {
            item.style.opacity = '1';
            item.style.transform = 'translateX(0)';
          }, 10);
        } else {
          item.style.opacity = '0';
          item.style.transform = 'translateX(100%)';
          setTimeout(() => {
            if (i !== index) {
              item.style.display = 'none';
              item.classList.remove('is-selected');
            }
          }, 600);
        }
      });
      this.updateArrows();

      const currentItem = this.items[this.currentIndex];
      if (currentItem) {
        const dataEls = currentItem.querySelectorAll('.shop-the-look-product-data');
        const dots = currentItem.querySelectorAll('.shop-the-look-fullwidth-dot');
        dots.forEach((d, idx) => {
          d.style.display = idx < dataEls.length ? 'inline-block' : 'none';
          d.classList.toggle('is-selected', idx === 0);
          d.setAttribute('aria-current', idx === 0 ? 'true' : 'false');
        });
        if (window.innerWidth <= 1024) setTimeout(() => this.adjustHotSpotsWidth(currentItem), 100);
      }
    }

    closeAllPopups() {
      const popups = this.querySelectorAll('.shop-the-look-fullwidth-tooltip');
      popups.forEach((popup) => this.closeTooltip(popup));
    }

    previous() {
      const newIndex = this.currentIndex > 0 ? this.currentIndex - 1 : this.items.length - 1;
      this.select(newIndex);
    }

    next() {
      const newIndex = this.currentIndex < this.items.length - 1 ? this.currentIndex + 1 : 0;
      this.select(newIndex);
    }

    updateArrows() {
      if (this.prevButton) this.prevButton.disabled = this.items.length <= 1;
      if (this.nextButton) this.nextButton.disabled = this.items.length <= 1;
    }

    cleanup() {
      if (this.boundHandleKeydown) {
        this.removeEventListener('keydown', this.boundHandleKeydown);
      }
      if (this.boundHandleTouchstart) {
        this.removeEventListener('touchstart', this.boundHandleTouchstart);
      }
      if (this.boundHandleTouchmove) {
        this.removeEventListener('touchmove', this.boundHandleTouchmove);
      }
      if (this.boundHandleTouchend) {
        this.removeEventListener('touchend', this.boundHandleTouchend);
      }
      if (this.boundHandleResize) {
        window.removeEventListener('resize', this.boundHandleResize);
      }
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }
    }
  }

  customElements.define('shop-the-look-fullwidth-carousel', ShopTheLookFullwidthCarousel);
}

// Store Locations Section
if (!customElements.get('byte-store-locations')) {
  class ByteStoreLocations extends HTMLElement {
    constructor() {
      super();
      this.countrySelect = null;
      this.dropdownSelected = null;
      this.dropdownOptions = null;
      this.dropdownValue = null;
      this.storeItems = null;
      this.countryImages = null;
      this.storeImages = null;
      this.defaultImage = null;
      this.countrySelected = false;
      this.currentCountryCode = 'none';
      this.currentCountryImage = null;
      this.boundHandleClickOutside = null;
      this.boundStoreHoverHandlers = [];
    }

    connectedCallback() {
      this.countrySelect = this.querySelector('#country-select');
      if (!this.countrySelect) return;

      this.dropdownSelected = this.countrySelect.querySelector('.dropdown-selected');
      this.dropdownOptions = this.countrySelect.querySelector('.dropdown-options');
      this.dropdownValue = this.countrySelect.querySelector('.dropdown-value');
      this.storeItems = this.querySelectorAll('.store-item');
      this.countryImages = this.querySelectorAll('.country-specific-image');
      this.storeImages = this.querySelectorAll('.store-hover-image');
      this.defaultImage = this.querySelector('.default-image');

      this.#setupEventListeners();
      this.#setupStoreHover();
      this.#initializeDefaultImage();
    }

    disconnectedCallback() {
      this.#cleanup();
    }

    #setupEventListeners() {
      // Dropdown functionality
      this.countrySelect.addEventListener('click', (e) => {
        e.stopPropagation();
        this.dropdownOptions.style.display = this.dropdownOptions.style.display === 'none' ? 'block' : 'none';
        this.countrySelect.classList.toggle('active');
      });

      // Close dropdown when clicking outside
      this.boundHandleClickOutside = (e) => {
        if (!this.countrySelect.contains(e.target)) {
          this.dropdownOptions.style.display = 'none';
          this.countrySelect.classList.remove('active');
        }
      };
      document.addEventListener('click', this.boundHandleClickOutside);

      // Handle option selection
      this.dropdownOptions.addEventListener('click', (e) => {
        if (e.target.classList.contains('dropdown-option')) {
          const selectedValue = e.target.getAttribute('data-value');
          const selectedText = e.target.textContent;

          // Update selected text
          this.dropdownSelected.textContent = selectedText;
          this.dropdownValue.value = selectedValue;

          // Update selected state
          this.dropdownOptions.querySelectorAll('.dropdown-option').forEach((option) => {
            option.classList.remove('selected');
          });
          e.target.classList.add('selected');

          // Force close dropdown
          setTimeout(() => {
            this.dropdownOptions.style.display = 'none';
            this.countrySelect.classList.remove('active');
          }, 10);

          // Update stores only
          this.#updateStores(selectedValue);

          // Prevent event bubbling
          e.stopPropagation();
          e.preventDefault();
        }
      });
    }

    #updateStores(countryCode) {
      // Hide all store items first
      this.storeItems.forEach((item) => {
        item.style.display = 'none';
      });

      // Update country image visibility
      this.#updateCountryImage(countryCode);

      // Show stores for selected country
      if (countryCode !== 'none') {
        this.countrySelected = true;
        this.currentCountryCode = countryCode;
        const countryStores = this.querySelectorAll(`.store-item[data-country="${countryCode}"]`);
        countryStores.forEach((store, index) => {
          setTimeout(() => {
            store.style.display = 'flex';
            store.classList.add('store-item-fade-in');
          }, index * 100);
        });
      } else {
        this.currentCountryCode = 'none';
      }
    }

    #updateCountryImage(countryCode) {
      // Hide all country images
      this.countryImages.forEach((img) => {
        img.style.display = 'none';
        img.style.opacity = '0';
      });

      // Hide default image
      if (this.defaultImage) {
        this.defaultImage.style.display = 'none';
        this.defaultImage.style.opacity = '0';
      }

      // Show country image if country is selected
      if (countryCode !== 'none') {
        const countryImage = this.querySelector(`.country-specific-image[data-country="${countryCode}"]`);
        if (countryImage) {
          countryImage.style.display = 'block';
          setTimeout(() => {
            countryImage.style.opacity = '1';
          }, 10);
          this.currentCountryImage = countryImage;
        } else {
          // If no country image, show default
          if (this.defaultImage) {
            this.defaultImage.style.display = 'block';
            this.defaultImage.style.opacity = '1';
          }
          this.currentCountryImage = null;
        }
      } else {
        // Show default image if no country selected
        if (this.defaultImage) {
          this.defaultImage.style.display = 'block';
          this.defaultImage.style.opacity = '1';
        }
        this.currentCountryImage = null;
      }
    }

    #showStoreImage(storeId) {
      // Hide country/default image
      if (this.currentCountryImage) {
        this.currentCountryImage.style.opacity = '0';
      }
      if (this.defaultImage && this.defaultImage.style.display !== 'none') {
        this.defaultImage.style.opacity = '0';
      }

      // Show store image
      const storeImage = this.querySelector(`.store-hover-image[data-store-id="${storeId}"]`);
      if (storeImage) {
        storeImage.style.display = 'block';
        setTimeout(() => {
          storeImage.style.opacity = '1';
        }, 10);
      }
    }

    #hideStoreImage(storeId) {
      // Hide store image
      const storeImage = this.querySelector(`.store-hover-image[data-store-id="${storeId}"]`);
      if (storeImage) {
        storeImage.style.opacity = '0';
        setTimeout(() => {
          storeImage.style.display = 'none';
        }, 300);
      }

      // Show country/default image again
      if (this.currentCountryImage) {
        this.currentCountryImage.style.display = 'block';
        setTimeout(() => {
          this.currentCountryImage.style.opacity = '1';
        }, 10);
      } else if (this.defaultImage) {
        this.defaultImage.style.display = 'block';
        setTimeout(() => {
          this.defaultImage.style.opacity = '1';
        }, 10);
      }
    }

    #initializeDefaultImage() {
      if (this.defaultImage) {
        this.defaultImage.style.display = 'block';
        this.defaultImage.style.opacity = '1';
      }
    }

    #setupStoreHover() {
      // Add hover event listeners to store items
      this.storeItems.forEach((storeItem) => {
        const storeId = storeItem.getAttribute('data-store-id');
        if (!storeId) return;

        const handleMouseEnter = () => {
          this.#showStoreImage(storeId);
        };

        const handleMouseLeave = () => {
          this.#hideStoreImage(storeId);
        };

        storeItem.addEventListener('mouseenter', handleMouseEnter);
        storeItem.addEventListener('mouseleave', handleMouseLeave);

        // Store handlers for cleanup
        this.boundStoreHoverHandlers.push({
          element: storeItem,
          enter: handleMouseEnter,
          leave: handleMouseLeave
        });
      });
    }

    #cleanup() {
      if (this.boundHandleClickOutside) {
        document.removeEventListener('click', this.boundHandleClickOutside);
      }

      // Remove store hover handlers
      this.boundStoreHoverHandlers.forEach(({ element, enter, leave }) => {
        element.removeEventListener('mouseenter', enter);
        element.removeEventListener('mouseleave', leave);
      });
      this.boundStoreHoverHandlers = [];
    }
  }

  customElements.define('byte-store-locations', ByteStoreLocations);
}

// Related Product Slider
if (!customElements.get('related-product-slider')) {
  class RelatedProductSlider extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.gap = 20;
      this.isMobile = window.innerWidth <= 768;
    }

    // Element DOM'a eklendiğinde çalışır
    connectedCallback() {
      this.slider = this.querySelector('[data-slider-track]');
      if (!this.slider) return;

      this.slides = this.slider.querySelectorAll('.related-product-slide');
      if (!this.slides.length) return;

      // Navigasyon butonlarını slider ID'si yerine element içindeki selector ile buluyoruz
      const sliderId = this.slider.id;
      this.prevBtn = document.querySelector(`[data-slider-id="${sliderId}"].related-slider-nav-prev`);
      this.nextBtn = document.querySelector(`[data-slider-id="${sliderId}"].related-slider-nav-next`);

      this.init();
    }

    init() {
      this.setupSlider();
      this.bindEvents();
      this.updateSlider();
    }

    setupSlider() {
      this.slider.style.transition = 'transform 0.3s ease';
      this.slider.style.display = 'flex';
      this.slider.style.gap = this.isMobile ? '0px' : this.gap + 'px';
      this.slider
        .querySelectorAll('img')
        .forEach((img) => img.addEventListener('dragstart', (e) => e.preventDefault()));
    }

    bindEvents() {
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prevSlide());
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.nextSlide());
      
      // Resize event'ini bir değişkene atıyoruz ki gerektiğinde temizleyebilelim
      this.resizeHandler = () => {
        this.isMobile = window.innerWidth <= 768;
        this.setupSlider();
        this.updateSlider();
      };
      window.addEventListener('resize', this.resizeHandler);
    }

    getSlideWidth() {
      const wrapper = this.slider.parentElement;
      const wrapperWidth = wrapper.offsetWidth;
      return this.isMobile ? wrapperWidth : (wrapperWidth - this.gap) / 2;
    }

    prevSlide() {
      if (this.currentIndex > 0) this.currentIndex--;
      this.updateSlider();
    }

    nextSlide() {
      const maxIndex = this.isMobile ? this.slides.length - 1 : this.slides.length - 2;
      if (this.currentIndex < maxIndex) this.currentIndex++;
      this.updateSlider();
    }

    updateSlider() {
      const slideWidth = this.getSlideWidth();
      const totalSlideWidth = this.isMobile ? slideWidth : slideWidth + this.gap;
      this.slider.style.transform = `translateX(-${this.currentIndex * totalSlideWidth}px)`;

      const maxIndex = this.isMobile ? this.slides.length - 1 : this.slides.length - 2;
      
      if (this.prevBtn) this.prevBtn.disabled = this.currentIndex === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.currentIndex >= maxIndex;
    }

    // Element DOM'dan kaldırıldığında hafıza sızıntısını önlemek için event'i temizliyoruz
    disconnectedCallback() {
      window.removeEventListener('resize', this.resizeHandler);
    }
  }

  // Custom element ismini tanımlıyoruz
  customElements.define('related-product-slider', RelatedProductSlider);
}

if (!customElements.get('byte-teklif-al')) {
  class ByteTeklifAl extends HTMLElement {
    constructor() {
      super();
      this.trigger = null;
      this.cities = null;
      this.boundHandleClickOutside = this.handleClickOutside.bind(this);
    }

    connectedCallback() {
      this.trigger = this.querySelector('[data-teklif-trigger]');
      this.cities = this.querySelector('.teklif-al__cities');
      if (this.trigger && this.cities) {
        this.trigger.addEventListener('click', () => this.toggle());
        document.addEventListener('click', this.boundHandleClickOutside);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.boundHandleClickOutside);
    }

    toggle() {
      this.cities.hidden = !this.cities.hidden;
      this.trigger.setAttribute('aria-expanded', this.cities.hidden ? 'false' : 'true');
    }

    handleClickOutside(e) {
      if (this.cities && !this.cities.hidden && !this.contains(e.target)) {
        this.cities.hidden = true;
        this.trigger.setAttribute('aria-expanded', 'false');
      }
    }
  }
  customElements.define('byte-teklif-al', ByteTeklifAl);
}
/* SEO Text Readmore */
if (!customElements.get('cst-readmore')) {
  class CstReadmore extends HTMLElement {
    connectedCallback() {
      const sid       = this.dataset.sectionId;
      const collapsed = parseInt(this.dataset.collapsedHeight, 10);
      const wrapper   = document.getElementById(sid + '-wrapper');
      const content   = document.getElementById(sid + '-content');
      const fade      = document.getElementById(sid + '-fade');
      const btn       = document.getElementById(sid + '-btn');
      const toggle    = document.getElementById(sid + '-toggle');

      const fullHeight = content.scrollHeight;

      if (fullHeight <= collapsed) {
        wrapper.style.maxHeight = fullHeight + 'px';
        fade.style.display = 'none';
        toggle.classList.add('hidden');
        return;
      }

      wrapper.style.maxHeight = collapsed + 'px';

      btn.addEventListener('click', () => {
        const isExpanded = btn.getAttribute('aria-expanded') === 'true';
        isExpanded ? this._collapse(sid, collapsed, wrapper, fade, btn) : this._expand(sid, wrapper, content, fade, btn);
      });
    }

    _expand(sid, wrapper, content, fade, btn) {
      wrapper.style.maxHeight = content.scrollHeight + 'px';
      fade.style.opacity = '0';
      setTimeout(() => { fade.style.display = 'none'; }, 400);
      btn.setAttribute('aria-expanded', 'true');
      btn.querySelector('.btn-label-more').style.display = 'none';
      btn.querySelector('.btn-label-less').style.display = 'inline';
      btn.querySelector('.cst-chevron').classList.add('rotated');
    }

    _collapse(sid, collapsed, wrapper, fade, btn) {
      wrapper.style.maxHeight = collapsed + 'px';
      fade.style.display = 'block';
      setTimeout(() => { fade.style.opacity = '1'; }, 10);
      btn.setAttribute('aria-expanded', 'false');
      btn.querySelector('.btn-label-more').style.display = 'inline';
      btn.querySelector('.btn-label-less').style.display = 'none';
      btn.querySelector('.cst-chevron').classList.remove('rotated');
      setTimeout(() => {
        document.getElementById(sid).scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    }
  }

  customElements.define('cst-readmore', CstReadmore);
}